export function getFooterColumnsWidths(columnWidths, visibleBusinessDetails, visibleSocialIcons, visibleSiteTitle) {
    var socialColumnWidth = visibleSocialIcons && visibleBusinessDetails
        ? columnWidths[1]
        : columnWidths[0];
    var businessColumnWidth = visibleBusinessDetails && columnWidths[0];
    var titleWidth = visibleSiteTitle && columnWidths[columnWidths.length - 1];
    return {
        socialColumnWidth: (socialColumnWidth && "".concat(socialColumnWidth, "%")) || undefined,
        businessColumnWidth: (businessColumnWidth && "".concat(businessColumnWidth, "%")) || undefined,
        titleWidth: (titleWidth && "".concat(titleWidth, "%")) || undefined,
    };
}
//# sourceMappingURL=footer-utils.js.map